import React from "react";
import classNames from "classnames";
import { UseCases } from "@planzone/core";
import { useMoveOrganizationalUnit } from "@planzone/view-models";
import { usePermissions } from "@scenes/safeguard";
import { Preview } from "@scenes/wbs/preview";
import { DropBox } from "@common/dragAndDrop";
import { ORGANIZATIONAL_UNIT_DRAG_TYPE } from "../../dragType";
import { Props } from "./types";
import styles from "./styles.scss";

function DropLine({ organizationalUnit, ancestorUuids }: Props) {
  const { moveOrganizationalUnit } = useMoveOrganizationalUnit();
  const { canMoveOrganizationalUnit } = usePermissions([
    UseCases.moveOrganizationalUnit,
  ]);
  const isRoot = ancestorUuids.length === 0;

  return (
    <DropBox
      className={classNames(styles.dropLine, { [styles.root]: isRoot })}
      acceptedTypes={[ORGANIZATIONAL_UNIT_DRAG_TYPE]}
      verticalSlop={{ top: 12, bottom: isRoot ? 12 : 0 }}
      isDisabled={({ payload }) =>
        !canMoveOrganizationalUnit ||
        payload.organizationalUnit?.uuid === organizationalUnit.uuid ||
        ancestorUuids.includes(payload.organizationalUnit?.uuid)
      }
      drop={({ payload }) =>
        moveOrganizationalUnit({
          organizationalUnit: payload.organizationalUnit,
          newParentUuid: organizationalUnit.parentUuid,
          insertAfterUuid: organizationalUnit.uuid,
        })
      }
    >
      {(_, canDrop) => <Preview canDrop={canDrop} />}
    </DropBox>
  );
}

export { DropLine };
